import React from "react";

export default function ChartLineUp(props: any) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.375 13C14.375 13.0995 14.3355 13.1948 14.2652 13.2652C14.1948 13.3355 14.0995 13.375 14 13.375H2C1.90054 13.375 1.80516 13.3355 1.73483 13.2652C1.66451 13.1948 1.625 13.0995 1.625 13V3C1.625 2.90054 1.66451 2.80516 1.73483 2.73483C1.80516 2.66451 1.90054 2.625 2 2.625C2.09946 2.625 2.19484 2.66451 2.26517 2.73483C2.33549 2.80516 2.375 2.90054 2.375 3V10.095L5.735 6.735C5.80531 6.66477 5.90062 6.62533 6 6.62533C6.09938 6.62533 6.19469 6.66477 6.265 6.735L8 8.46937L11.595 4.875H10C9.90054 4.875 9.80516 4.83549 9.73483 4.76516C9.66451 4.69484 9.625 4.59946 9.625 4.5C9.625 4.40054 9.66451 4.30516 9.73483 4.23484C9.80516 4.16451 9.90054 4.125 10 4.125H12.5C12.5995 4.125 12.6948 4.16451 12.7652 4.23484C12.8355 4.30516 12.875 4.40054 12.875 4.5V7C12.875 7.09946 12.8355 7.19484 12.7652 7.26516C12.6948 7.33549 12.5995 7.375 12.5 7.375C12.4005 7.375 12.3052 7.33549 12.2348 7.26516C12.1645 7.19484 12.125 7.09946 12.125 7V5.405L8.265 9.265C8.19469 9.33523 8.09938 9.37467 8 9.37467C7.90062 9.37467 7.80531 9.33523 7.735 9.265L6 7.53063L2.375 11.1556V12.625H14C14.0995 12.625 14.1948 12.6645 14.2652 12.7348C14.3355 12.8052 14.375 12.9005 14.375 13Z"
        fill="white"
      />
    </svg>
  );
}
